import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { X, EyeOff } from "lucide-react";

/** Modal admin : refuser la réponse d'un restaurant à un avis, avec motif optionnel. */
export default function RejectReplyModal({ review, onClose, onConfirm }) {
  const { t } = useTranslation();
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    setBusy(true);
    try {
      await onConfirm(reason.trim() || null);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/50 grid place-items-center p-4" data-testid="reject-reply-modal">
      <div className="bg-white rounded-2xl w-full max-w-md p-6 relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-mute hover:text-ink" data-testid="reject-reply-modal-close" aria-label="Fermer">
          <X className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-brand-red/10 text-brand-red grid place-items-center shrink-0">
            <EyeOff className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-display text-lg font-semibold">{t("admin.rrTitle")}</h3>
            <div className="text-sm text-mute">{review.reply_author || "Restaurant"} · avis de {review.user_name}</div>
          </div>
        </div>

        <div className="bg-elevated rounded-xl p-3 text-sm text-ink mb-4 max-h-28 overflow-y-auto">
          "{review.reply}"
        </div>

        <label className="text-sm font-medium text-ink block mb-1.5">Motif du refus <span className="text-mute font-normal">(visible par le restaurant, optionnel)</span></label>
        <textarea
          data-testid="reject-reason-textarea"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          maxLength={300}
          placeholder={t("admin.rrPh")}
          className="w-full bg-elevated rounded-xl px-3 py-2 outline-none text-sm mb-4"
        />

        <div className="flex gap-2 justify-end">
          <button onClick={onClose} disabled={busy} className="text-sm rounded-full px-4 py-2 border border-sand" data-testid="reject-reply-cancel">Annuler</button>
          <button onClick={confirm} disabled={busy} data-testid="reject-reply-confirm" className="text-sm inline-flex items-center gap-1.5 rounded-full bg-brand-red text-white px-4 py-2 font-semibold disabled:opacity-60">
            <EyeOff className="w-3.5 h-3.5" /> {busy ? t("admin.rrBusy") : t("admin.rrConfirm")}
          </button>
        </div>
      </div>
    </div>
  );
}
